module.exports = __webpack_public_path__ + "static/video-poster-360418df54647837944c3e588d3ab12c.webp";